module.exports = __webpack_public_path__ + "assets/img/businessToBusiness.dfa1f357.png";